<template>
    <div class="view">
        <div v-html="article.ssContent"></div>
    </div>
    </template>
    <script>
        import {apiService, RESULT_CODE} from "@/api/ApiService.js"
        export default {
            name: 'SchoolSummarizeArticle',
            data: function() {
                return {
                    article: {}
                }
            },
            mounted() {
                this.init()
            },
            watch: {'$route': 'init'},
            methods: {
                init () {
                    let {ssType} = this.$route.query
                    apiService.findSchoolSummarizeByType(ssType).then(res => {
                    this.article = res.data
                })
                }
            }
        }
    </script>
    <style scoped>
        .view {
            padding: 0.25rem;
            background-color: #fff;
        }
        
    </style>


// WEBPACK FOOTER //
// src/components/SchoolSummarizeArticle.vue